export const ENVIRONMENTS_ENUMS = {
  LOCAL: "local",
  PROD: "prod",
};

// TODO: If there is any dev, stg and prod url rewrite this using that links
const envPatterns = {
  PROD: /.*pharmatechuni.uz/g,
  PROD_PHTU: /.*phtu.uz/g,
};

export const getCurrentEnvironment = () => {
  const nodeEnv = process.env.NODE_ENV;
  const apiHost = process.env.REACT_APP_API_HOST;

  console.log("nodeEnv", nodeEnv);
  console.log("apiHost", apiHost);

  if (nodeEnv === "production") {
    console.log("PROD based on NODE_ENV");
    return ENVIRONMENTS_ENUMS.PROD;
  }

  if (nodeEnv === "development") {
    console.log("DEV based on NODE_ENV");
    return ENVIRONMENTS_ENUMS.LOCAL;
  }

  // Fallback to host pattern detection
  if (envPatterns.PROD.test(apiHost || "")) {
    console.log("PROD based on API host");
    return ENVIRONMENTS_ENUMS.PROD;
  }

  console.log("LOCAL (fallback)");
  return ENVIRONMENTS_ENUMS.LOCAL;
};
